import markdownit from 'markdown-it';
import { get } from 'svelte/store';
import { ConfigStore } from '../store/config';

export class MarkupHelper {
  private md: any;

  constructor() {
    this.md = markdownit({
      html: true,
      linkify: true,
      typographer: true,
    });

    const defaultLinkOpen =
      this.md.renderer.rules.link_open ??
      ((tokens: any, idx: number, options: any, _env: any, self: any) =>
        self.renderToken(tokens, idx, options));

    this.md.renderer.rules.link_open = (
      tokens: any,
      idx: number,
      options: any,
      env: any,
      self: any
    ) => {
      const target = get(ConfigStore).hyperlinkTargetType;
      tokens[idx].attrSet('target', target);

      return defaultLinkOpen(tokens, idx, options, env, self);
    };
  }

  public render(input: string, allowedDomains: string[] | undefined): string {
    if (input) {
      return this.sanitiseContent(this.md.render(input), allowedDomains);
    } else {
      return '';
    }
  }

  private sanitiseContent(html: string, allowedDomains?: string[]): string {
    if (allowedDomains) {
        // normalize allow‐list
        const allowed = allowedDomains.map(d => d.toLowerCase());
        const isAllowedDomain = (host: string) =>
          allowed.some(domain =>
            host === domain || host.endsWith(`.${domain}`)
          );

        // Parse the HTML safely using DOMParser
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Iterate all links
        doc.querySelectorAll('a[href]').forEach(link => {
          const href = link.getAttribute('href')!.trim();
          let domain: string | null = null;

          if (/^tel:/i.test(href)) {
            // iOS may add telephone links while DOMParser parses plain text.
            const phoneNumber = doc.createTextNode(link.textContent ?? '');
            link.parentNode?.replaceChild(phoneNumber, link);
            return;
          } else if (/^mailto:/i.test(href)) {
            // mailto:foo@domain.com
            const email = href.slice(7);
            const parts = email.split('@');
            domain = parts[1]?.toLowerCase() ?? null;
          } else {
            try {
              domain = new URL(href).hostname.toLowerCase();
            } catch {
              domain = null;
            }
          }

          // If domain not allowed, replace the entire <a> with "[REDACTED]"
          if (domain === null || domain === '' || !isAllowedDomain(domain)) {
            const redactedText = document.createTextNode('[REDACTED]');
            link.parentNode?.replaceChild(redactedText, link);
          }
          // otherwise leave the <a> exactly as-is
        });

        return doc.body.innerHTML;
    } else {
      // If no allowed domains, return content as is
      return html;
    }
  }
}
